// Página principal del panel de administración
// Muestra la tabla de usuarios con paginación y búsqueda

import UsersTable from '../../../../components/users/UsersTable';
import { useAdminUsers } from '../../../../hooks/useAdminUsers';
import SexualPreferencesCards from '../components/SexualPreferencesCards';
import { useSexualPreferences } from '../../../../hooks/useSexualPreferences';

export default function DashboardPage() {
	// Hook personalizado para gestionar usuarios con paginación
	const {
		users,
		isLoading,
		isError,
		error,
		hasNextPage,
		totalCount,
		searchText,
		orderBy,
		cursor,
		loadNextPage,
		resetToFirstPage,
		handleSearchChange,
		handleOrderByChange,
		refetchUsers
	} = useAdminUsers();

	// Hook para obtener métricas de preferencias sexuales
	const {
		data: preferencesData,
		isLoading: preferencesLoading,
		isError: preferencesError,
		error: preferencesErrorData,
		refetch: refetchPreferences,
	} = useSexualPreferences();

	return (
    <article className='p-4 w-full overflow-hidden'>

				{/* componente de cards para contabilizar gustos o intereses */}
				<SexualPreferencesCards
					data={preferencesData}
					isLoading={preferencesLoading}
					isError={preferencesError}
					error={preferencesErrorData}
					refetch={refetchPreferences}
				/>

				{/* Tabla de usuarios con paginación y búsqueda */}
				<UsersTable
					users={users}
					isLoading={isLoading}
					isError={isError}
					error={error}
					hasNextPage={hasNextPage}
					totalCount={totalCount}
					searchText={searchText}
					orderBy={orderBy}
					cursor={cursor}
					onLoadNextPage={loadNextPage}
					onResetPage={resetToFirstPage}
					onSearchChange={handleSearchChange}
					onOrderByChange={handleOrderByChange}
					onRefetch={refetchUsers}
				/>
    </article>
	)
}